import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import NovidadesModal from "../components/NovidadesModal";
import { novidadesPara, publicoDoUsuario, marcarNovidadeVista, dataCurta } from "../data/novidades";

// /novidades — todas as novidades do público da pessoa, da mais nova para a mais antiga. Serve também de link em
// e-mail e post. Sem login, mostra as de candidato (quem chega por um post quase sempre é candidato).
export default function NovidadesPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const publico = publicoDoUsuario(user) || "candidato";
  const lista = novidadesPara(publico);
  const [modal, setModal] = useState(null);

  const abrir = (i) => { if (user) marcarNovidadeVista(user, lista[i].id); setModal(i); };
  const acao = (n) => { if (user) marcarNovidadeVista(user, n.id); navigate(n.link); };

  return (
    <div className="mx-auto max-w-3xl px-4 py-8">
      <h1 className="text-2xl font-bold text-primary">Novidades do eaiRH</h1>
      <p className="mb-6 text-sm text-gray-500">
        {publico === "empresa" ? "O que há de novo para empresas." : "O que há de novo para você que está buscando vaga."}
      </p>
      {lista.map((n, i) => (
        <div key={n.id} className="mb-3 flex gap-4 rounded-xl border border-gray-200 bg-white p-4">
          <div className="text-3xl">{n.ic}</div>
          <div className="min-w-0">
            <h2 className="mb-1 text-base font-bold text-primary">{n.titulo}</h2>
            <p className="mb-2 text-sm text-gray-700">{n.texto}</p>
            <span className="text-xs text-gray-400">{dataCurta(n.data)}</span>
            <span className="text-xs text-gray-300"> · </span>
            <button onClick={() => abrir(i)} className="text-sm font-bold text-orange-500 hover:underline">{n.cta} ›</button>
          </div>
        </div>
      ))}
      {modal !== null && (
        <NovidadesModal lista={lista} indice={modal}
          onIndice={(i) => { if (i >= 0 && i < lista.length) { if (user) marcarNovidadeVista(user, lista[i].id); setModal(i); } }}
          onFechar={() => setModal(null)} onAcao={acao} />
      )}
    </div>
  );
}
